(function () {

    'use strict';

    var injects = [
        'schemaForm',
        'schemaForm-currency',
        'pascalprecht.translate',
        'ui.router',
        'angularModalService',
        'ngMask',
        'ngAnimate',
        'ngResource',
        'angularMoment',
        'firebase',
        'ui.bootstrap',
        'datetimepicker',
        'ngSanitize',
        'textAngular',
        'ngFileUpload',
        'ui.utils.masks',
        'ui.grid',
        'ui.grid.cellNav',
        'ui.grid.edit',
        'ui.grid.resizeColumns',
        'ui.grid.pinning',
        'ui.grid.selection',
        'ui.grid.moveColumns',
        'ui.grid.exporter',
        'ui.grid.importer',
        'ui.grid.grouping',
        'ui.grid.autoResize',
        'LocalForageModule',
        'angular-stripe',
        'dndLists'
    ];

	var ngModule = angular.module('breakmarkApp', injects);

	ngModule.constant('fbUrl', 'https://breakmark.firebaseio.com');

    ngModule.config(function() {
          /* Initialize Firebase */
          var config = {
            apiKey: "AIzaSyDEqTytoDyTfzANnvXJFhLNaYQcoCYEeko",
            authDomain: "breakmark.firebaseapp.com",
            databaseURL: "https://breakmark.firebaseio.com",
            storageBucket: "project-676954171809794961.appspot.com",
            // messagingSenderId: "801106205815"
          };

          firebase.initializeApp(config);

    });

	ngModule.config(function($sceDelegateProvider, $provide) {
		$sceDelegateProvider.resourceUrlWhitelist([ 'self' ]);

        $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function(taRegisterTool, taOptions){

            taOptions.toolbar = [
                ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol','wordcount', 'charcount'],
                ['insertImage','insertLink', 'justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent','redo', 'undo', 'clear' ]
            ];

            return taOptions;
        }]);

	});

    ngModule.config(function(stripeProvider) {
        stripeProvider.setPublishableKey('pk_live_Jf0Z2Hn2w3JsFBCoWBbcCINz');
    })

    ngModule.run(["$rootScope", "$state", 'Auth', function($rootScope, $state, Auth) {

        console.log('Updated May 24, 2019 @ 12:14 AM EST');

        /* Set the session state. */
        $rootScope.hasLogin = false;
        $rootScope.Auth = Auth;

        // This watched for a state change and forces the UI to a new state.
        $rootScope.Auth.$onAuthStateChanged(function(user) {

            // if (!user) $state.go('login');

            // $rootScope.hasLogin = (user !== null);

        });

        /* This watches for errors in the router and forces a state change. */
        $rootScope.$on("$stateChangeError", function(event, toState, toParams, fromState, fromParams, error) {
            // We can catch the error thrown when the $requireSignIn promise is rejected
            // and redirect the user back to the home page
            // console.log('$stateChangeError', error);
            // console.log('has login', $rootScope.hasLogin);
            //
            if (error === "AUTH_REQUIRED") {
                // console.log('going to login screen');
                $state.go("login");
            } else {
                // $rootScope.hasLogin = true;
                console.log('$stateChangeError -> error', error);
            }
        });

        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){

            // console.log('stageChangeStart', toState, toParams, fromState, fromParams);
            // //
            // // let test = firebase.auth().currentUser;
            // //
            // // console.log('currentUser', test);
            // //
            // // console.log('on -> stateChangeStart');
            // // console.log('has login', $rootScope.hasLogin, $rootScope.Auth);
            // /* Set the state for the Header to use. */
            // // $rootScope.currentState = toState.name;
            //
            if(toState.needsAuth){

                console.log('firebase.auth().currentUser', firebase.auth().currentUser);

                if($rootScope.hasLogin === firebase.auth().currentUser){

                    $rootScope.currentState = toState.name;

                } else {

                    let user = firebase.auth().currentUser;

                    if(user){

                        $rootScope.hasLogin = user;

                        $rootScope.currentState = toState.name;

                    } else {

                        $state.go('login');

                    }

                }

            } else {

                $rootScope.currentState = toState.name;

            }
            // if(toState.needsAuth && $rootScope.hasLogin){
            //     // console.log('everything is fine.')
            //     $rootScope.currentState = toState.name;
            // } else {
            //     // console.log('going to login');
            //     $state.go('login');
            // }

            // console.log('stateChangeStart', event, toState, toParams, fromState, fromParams, $rootScope.Auth, $rootScope.hasLogin);
        });

        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            // if(toState.needsAuth){
            //     if($rootScope.hasLogin){
            //         //console.log('everything is fine.')
            //         $rootScope.currentState = toState.name;
            //     } else {
            //         //console.log('stateChangeSuccess -> going to login screen');
            //         $state.go('login');
            //     }
            // } else {
            //     $rootScope.currentState = toState.name;
            // }
        });

    }]);

})();
